import { render, staticRenderFns } from "./activityEdit.vue?vue&type=template&id=5ef04c82&scoped=true&"
import script from "./activityEdit.vue?vue&type=script&lang=js&"
export * from "./activityEdit.vue?vue&type=script&lang=js&"
import style0 from "./activityEdit.vue?vue&type=style&index=0&id=5ef04c82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef04c82",
  null
  
)

export default component.exports